export const SkypeSecond = ({
  width = '16',
  height = '16',
  color = 'white',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_19_11184)">
        <path
          d="M16.04 9.698C16.156 9.177 16.216 8.637 16.216 8.083C16.216 3.928 12.8 0.559 8.585 0.559C8.141 0.559 7.705 0.597 7.28 0.669C6.598 0.246 5.791 0 4.926 0C2.481 0 0.5 1.953 0.5 4.364C0.5 5.169 0.722 5.922 1.108 6.571C1.007 7.059 0.953 7.565 0.953 8.083C0.953 12.239 4.37 15.608 8.584 15.608C9.062 15.608 9.529 15.564 9.982 15.482C10.606 15.812 11.318 16 12.075 16C14.519 16 16.5 14.046 16.5 11.637C16.5 10.94 16.334 10.283 16.04 9.698ZM12.499 11.679C12.146 12.172 11.625 12.562 10.948 12.838C10.279 13.113 9.478 13.253 8.564 13.253C7.468 13.253 6.549 13.063 5.831 12.687C5.318 12.414 4.896 12.045 4.575 11.587C4.25 11.127 4.087 10.67 4.087 10.228C4.087 9.953 4.194 9.714 4.405 9.519C4.614 9.324 4.882 9.227 5.202 9.227C5.464 9.227 5.69 9.304 5.874 9.457C6.049 9.604 6.2 9.822 6.321 10.101C6.456 10.407 6.603 10.665 6.758 10.866C6.909 11.063 7.124 11.227 7.399 11.356C7.676 11.484 8.049 11.551 8.507 11.551C9.138 11.551 9.656 11.418 10.044 11.156C10.425 10.901 10.609 10.593 10.609 10.217C10.609 9.921 10.512 9.687 10.315 9.504C10.107 9.312 9.833 9.163 9.501 9.06C9.154 8.954 8.683 8.838 8.101 8.718C7.308 8.551 6.635 8.353 6.101 8.128C5.554 7.898 5.112 7.58 4.79 7.182C4.462 6.777 4.296 6.27 4.296 5.674C4.296 5.106 4.47 4.594 4.814 4.152C5.155 3.713 5.653 3.37 6.296 3.137C6.929 2.906 7.682 2.789 8.535 2.789C9.216 2.789 9.815 2.867 10.316 3.021C10.819 3.175 11.243 3.383 11.576 3.64C11.912 3.9 12.162 4.175 12.318 4.463C12.476 4.753 12.557 5.042 12.557 5.321C12.557 5.59 12.452 5.835 12.244 6.047C12.034 6.262 11.77 6.37 11.46 6.37C11.178 6.37 10.956 6.301 10.803 6.168C10.66 6.043 10.511 5.848 10.347 5.57C10.157 5.214 9.926 4.933 9.662 4.734C9.405 4.541 8.977 4.445 8.387 4.445C7.841 4.445 7.395 4.553 7.065 4.767C6.747 4.972 6.592 5.208 6.592 5.488C6.592 5.659 6.642 5.802 6.745 5.925C6.853 6.057 7.006 6.17 7.2 6.266C7.4 6.365 7.607 6.445 7.814 6.501C8.026 6.559 8.381 6.646 8.87 6.757C9.488 6.887 10.055 7.034 10.557 7.193C11.066 7.352 11.504 7.549 11.864 7.78C12.229 8.015 12.518 8.315 12.724 8.675C12.93 9.038 13.034 9.483 13.034 10.001C13.033 10.62 12.853 11.185 12.499 11.679Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_19_11184">
          <rect
            width={width}
            height={height}
            fill={color}
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
